import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { interval, Subscription } from "rxjs";
import { AppState } from "src/app/state/app.state";
import { environment } from "src/environments/environment";
import { setCardIdInUrl, setCardScanBypassed } from "../../transaction-info/state/transaction-info.actions";

@Component({
    selector: "app-card-scan",
    templateUrl: "./card-scan.component.html",
    styleUrls: ["./card-scan.component.scss"],
    standalone: false
})
export class CardScanComponent implements OnInit,OnDestroy {
	public showBtnNext = false;
	private subs: Subscription[] = [];

	constructor(private store: Store<AppState>) {
	}

	ngOnInit(): void {
		if (environment.kioskMode) {
			this.subs.push(
				interval(10000).subscribe(() => {
					this.showBtnNext = true;
				})
			);
		}
	}

	ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
		this.store.dispatch(setCardIdInUrl({data:null}));
	}

	public onClickOk() {
		this.store.dispatch(setCardScanBypassed({ data: true }));
	}
}
